import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PRIVILEGES from '../constants/privileges';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { RBACRoute } from './RBACRoute';

const Vehicles = lazy(() => import('../modules/vehicles'));
const VehiclesSection = lazy(
  () => import('../modules/vehicles/pages/VehiclesSection')
);

const VehiclesRoutes = (
  <>
    <Route
      path="vehicles"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <Vehicles />
        </Suspense>
      }
    >
      <Route
        path=""
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.VEHICLE_VIEW]}>
            <Suspense fallback={<SkeletonPage />}>
              <VehiclesSection />
            </Suspense>
          </RBACRoute>
        }
      />
    </Route>
  </>
);

export default VehiclesRoutes;
